import React from 'react';
import { string, arrayOf, shape } from 'prop-types';
import classNames from 'classnames/bind';

import Wysiwyg from 'components/Wysiwyg';
import BlockTitle from '../BlockTitle';

import styles from './ParagraphTextText.module.scss';
const cx = classNames.bind(styles);

const ParagraphTextText = ({ data }) => (
  <div className={cx('root')}>
    {data.map((item, i) => (
      <div key={i} className={cx('column')}>
        {item.title && <BlockTitle title={item.title} />}

        <Wysiwyg className={cx('item')} text={item.text} />
      </div>
    ))}
  </div>
);

ParagraphTextText.propTypes = {
  data: arrayOf(
    shape({
      title: string,
      text: string.isRequired,
    })
  ).isRequired,
};

export default ParagraphTextText;



// WEBPACK FOOTER //
// ./src/pages/TechnicalDocument/components/ParagraphTextText/ParagraphTextText.js